import { useState, useEffect } from "react";
import { apiFetch } from "../services/api.js";

export default function HistoricoSorteios({ reloadKey = 0 }) {
  const [campanhas, setCampanhas] = useState([]);
  const [anuais, setAnuais] = useState([]);
  const [execucoesAtivas, setExecucoesAtivas] = useState({});
  const [resultadosAtivos, setResultadosAtivos] = useState({});

  useEffect(() => {
    carregarDados();
  }, [reloadKey]);

  async function carregarDados() {
    try {
      const [campanhasRes, anuaisRes] = await Promise.all([
        apiFetch("campanhas"),
        apiFetch("anuais"),
      ]);
      setCampanhas(campanhasRes?.campanhas || []);
      setAnuais(anuaisRes?.anuais || []);
      console.log("[HISTORICO] Dados carregados");
    } catch (err) {
      console.error("[ERRO HISTORICO]", err);
    }
  }

  async function carregarExecucoes(tipo, id) {
    try {
      const res = await apiFetch(
        tipo === "campanha"
          ? `campanhas/${id}/execucoes`
          : `anuais/${id}/execucoes`,
      );
      setExecucoesAtivas((prev) => ({
        ...prev,
        [id]: res.execucoes || [],
      }));
      console.log(
        `[EXECUCOES] ${tipo}: ${res.execucoes?.length || 0} encontradas`,
      );
    } catch (err) {
      console.error("[ERRO EXECUCOES]", err);
    }
  }

  async function carregarResultados(execucaoId) {
    try {
      const res = await apiFetch(`execucoes/${execucaoId}/resultados`);
      setResultadosAtivos((prev) => ({
        ...prev,
        [execucaoId]: res.resultados || [],
      }));
    } catch (err) {
      console.error("[ERRO RESULTADOS]", err);
    }
  }

  async function desfazerSorteio(execucaoId) {
    if (!window.confirm("Desfazer este sorteio permanentemente?")) return;

    try {
      await apiFetch(`execucoes/${execucaoId}`, { method: "DELETE" });
      console.log("[SORTEIO] Desfeito ID: " + execucaoId);
      carregarDados();
      alert("Sorteio desfeito com sucesso");
    } catch (err) {
      alert("Erro: " + err.message);
      console.error("[ERRO DESFAZER]", err);
    }
  }

  function exportarParaExcel(execucaoId, resultados) {
    if (!resultados.length) {
      alert("Nenhum resultado para exportar");
      return;
    }

    // Criar CSV com dados dos resultados
    const headers = ["Posição", "Nome", "CPF/CNPJ", "Cupom", "Campanha"];
    const rows = resultados.map((r, idx) => [
      String(idx + 1),
      r.cliente_nome || "N/A",
      r.cliente_documento || "N/A",
      r.cupom_codigo || "N/A",
      r.campanha_nome || "N/A",
    ]);

    // Escapar valores com aspas e usar semicolon como delimitador (padrão UTF-8 en PT)
    const escapeCSV = (cell) => {
      const cellStr = String(cell || "");
      // Se contém semicolon, nova linha ou aspas, envolva em aspas e escape as aspas
      if (cellStr.includes(";") || cellStr.includes("\n") || cellStr.includes('"')) {
        return `"${cellStr.replace(/"/g, '""')}"`;
      }
      return cellStr;
    };

    // Combinar headers + dados com semicolon
    const csvContent = [
      "\uFEFF" + headers.map(escapeCSV).join(";"), // BOM UTF-8 + headers
      ...rows.map((row) => row.map(escapeCSV).join(";")),
    ].join("\n");

    // Criar blob e fazer download
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    const dataAtual = new Date().toISOString().split("T")[0];
    link.setAttribute("href", url);
    link.setAttribute("download", `sorteio-${dataAtual}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return (
    <div style={{ borderTop: "2px solid #ddd", paddingTop: "2rem" }}>
      <h3>Log | Historico de Sorteios</h3>

      <div
        style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "2rem" }}
      >
        {/* CAMPANHAS */}
        <div>
          <h4>Campanhas</h4>
          {campanhas.length === 0 ? (
            <p style={{ color: "#999" }}>Nenhuma campanha criada</p>
          ) : (
            campanhas.map((campanha) => (
              <div
                key={campanha.id}
                style={{
                  backgroundColor: "#f5f5f5",
                  padding: "1rem",
                  borderRadius: "6px",
                  marginBottom: "1rem",
                  border: "1px solid #ddd",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <strong>{campanha.nome}</strong>
                    <p
                      style={{
                        margin: "0.25rem 0",
                        fontSize: "0.9rem",
                        color: "#666",
                      }}
                    >
                      Prefixo: {campanha.prefixo} | Max:{" "}
                      {campanha.quantidade_maxima_cupons} cupons |{" "}
                      {campanha.quantidade_premios} premios
                    </p>
                  </div>
                  <button
                    onClick={() => carregarExecucoes("campanha", campanha.id)}
                    style={{
                      padding: "0.5rem 1rem",
                      backgroundColor: "#0066cc",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                      cursor: "pointer",
                      fontSize: "0.9rem",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Ver Execucoes
                  </button>
                </div>

                {execucoesAtivas[campanha.id] &&
                  execucoesAtivas[campanha.id].length > 0 && (
                    <div
                      style={{
                        marginTop: "1rem",
                        paddingTop: "1rem",
                        borderTop: "1px solid #ddd",
                      }}
                    >
                      {execucoesAtivas[campanha.id].map((exec) => (
                        <div
                          key={exec.id}
                          style={{
                            fontSize: "0.9rem",
                            padding: "0.5rem",
                            backgroundColor: "#fff",
                            borderRadius: "4px",
                            marginBottom: "0.5rem",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div>
                            <strong>
                              {new Date(exec.criado_em).toLocaleString()}
                            </strong>
                          </div>
                          <div style={{ display: "flex", gap: "0.5rem" }}>
                            <button
                              onClick={() => carregarResultados(exec.id)}
                              style={{
                                padding: "0.4rem 0.8rem",
                                backgroundColor: "#5cb85c",
                                color: "white",
                                border: "none",
                                borderRadius: "3px",
                                cursor: "pointer",
                                fontSize: "0.8rem",
                              }}
                            >
                              Ver
                            </button>
                            <button
                              onClick={() => desfazerSorteio(exec.id)}
                              style={{
                                padding: "0.4rem 0.8rem",
                                backgroundColor: "#d9534f",
                                color: "white",
                                border: "none",
                                borderRadius: "3px",
                                cursor: "pointer",
                                fontSize: "0.8rem",
                              }}
                            >
                              Desfazer
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
              </div>
            ))
          )}
        </div>

        {/* ANUAIS */}
        <div>
          <h4>Sorteios Anuais</h4>
          {anuais.length === 0 ? (
            <p style={{ color: "#999" }}>Nenhum sorteio anual criado</p>
          ) : (
            anuais.map((anual) => (
              <div
                key={anual.id}
                style={{
                  backgroundColor: "#f5f5f5",
                  padding: "1rem",
                  borderRadius: "6px",
                  marginBottom: "1rem",
                  border: "1px solid #ddd",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <strong>{anual.nome}</strong>
                    <p
                      style={{
                        margin: "0.25rem 0",
                        fontSize: "0.9rem",
                        color: "#666",
                      }}
                    >
                      {anual.quantidade_premios} premios |{" "}
                      {anual.ativo ? "Ativo" : "Inativo"}
                    </p>
                  </div>
                  <button
                    onClick={() => carregarExecucoes("anual", anual.id)}
                    style={{
                      padding: "0.5rem 1rem",
                      backgroundColor: "#0066cc",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                      cursor: "pointer",
                      fontSize: "0.9rem",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Ver Execucoes
                  </button>
                </div>

                {execucoesAtivas[anual.id] &&
                  execucoesAtivas[anual.id].length > 0 && (
                    <div
                      style={{
                        marginTop: "1rem",
                        paddingTop: "1rem",
                        borderTop: "1px solid #ddd",
                      }}
                    >
                      {execucoesAtivas[anual.id].map((exec) => (
                        <div
                          key={exec.id}
                          style={{
                            fontSize: "0.9rem",
                            padding: "0.5rem",
                            backgroundColor: "#fff",
                            borderRadius: "4px",
                            marginBottom: "0.5rem",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div>
                            <strong>
                              {new Date(exec.criado_em).toLocaleString()}
                            </strong>
                          </div>
                          <div style={{ display: "flex", gap: "0.5rem" }}>
                            <button
                              onClick={() => carregarResultados(exec.id)}
                              style={{
                                padding: "0.4rem 0.8rem",
                                backgroundColor: "#5cb85c",
                                color: "white",
                                border: "none",
                                borderRadius: "3px",
                                cursor: "pointer",
                                fontSize: "0.8rem",
                              }}
                            >
                              Ver
                            </button>
                            <button
                              onClick={() => desfazerSorteio(exec.id)}
                              style={{
                                padding: "0.4rem 0.8rem",
                                backgroundColor: "#d9534f",
                                color: "white",
                                border: "none",
                                borderRadius: "3px",
                                cursor: "pointer",
                                fontSize: "0.8rem",
                              }}
                            >
                              Desfazer
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
              </div>
            ))
          )}
        </div>
      </div>

      {/* RESULTADO MODAL */}
      {Object.keys(resultadosAtivos).length > 0 &&
        Object.entries(resultadosAtivos).map(([execId, resultados]) => {
          if (!resultados.length) return null;
          return (
            <div
              key={execId}
              style={{
                marginTop: "2rem",
                padding: "1rem",
                backgroundColor: "#f0f0f0",
                borderRadius: "6px",
                border: "1px solid #ccc",
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem" }}>
                <h4 style={{ margin: 0 }}>Ganhadores da Execução</h4>
                <button
                  onClick={() => exportarParaExcel(execId, resultados)}
                  style={{
                    padding: "0.5rem 1rem",
                    backgroundColor: "#27ae60",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "0.9rem",
                    whiteSpace: "nowrap",
                  }}
                >
                  📥 Exportar Excel
                </button>
              </div>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: "0.9rem",
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: "#333", color: "white" }}>
                    <th style={{ padding: "0.5rem" }}>Posicao</th>
                    <th style={{ padding: "0.5rem" }}>Nome</th>
                    <th style={{ padding: "0.5rem" }}>CPF/CNPJ</th>
                    <th style={{ padding: "0.5rem" }}>Cupom</th>
                  </tr>
                </thead>
                <tbody>
                  {resultados.map((r, idx) => (
                    <tr
                      key={idx}
                      style={{
                        backgroundColor: "#fff",
                        borderBottom: "1px solid #ddd",
                      }}
                    >
                      <td style={{ padding: "0.5rem" }}>
                        <strong>{r.premiacao_posicao}</strong>
                      </td>
                      <td style={{ padding: "0.5rem" }}>
                        {r.cliente_nome || "N/A"}
                      </td>
                      <td style={{ padding: "0.5rem" }}>
                        {r.cliente_documento || "N/A"}
                      </td>
                      <td
                        style={{
                          padding: "0.5rem",
                          fontWeight: "bold",
                          color: "#0066cc",
                        }}
                      >
                        {r.cupom_codigo}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          );
        })}
    </div>
  );
}
